import { render } from "./TasksListView.vue?vue&type=template&id=1b22637a"
import script from "./TasksListView.vue?vue&type=script&lang=js"
export * from "./TasksListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__